import { configureStore } from '@reduxjs/toolkit';
import totalRecordSlice from './totalRecordSlice';
import appLogoSlice from './appLogoSlice';
import filterslice from './reducer/filterslice';
import dateRangeSlice from './reducer/dateRangeSlice';
import notificationReducer from './sampleRedux';

const store = configureStore({
    reducer: {
        totalRecords: totalRecordSlice,
        company: appLogoSlice,
        filters: filterslice,
        dateRange:dateRangeSlice,
        notifications: notificationReducer,
    },
});

export default store;
